<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Reclamaciones</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative">
          <div class="w-full w-md-auto md-flex-1">
            <div class="d-flex justify-content-between align-items-center justify-content-lg-start">
              <button type="button" class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters">
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-md-none">
                <button type="button" class="button-tooltip text-dark font-weight-bold m-0" v-b-tooltip.hover
                  title="Recargar" @click="loadData()">
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0">
            <div class="d-none d-md-flex">
              <button type="button" class="button-tooltip text-dark font-weight-bold" v-b-tooltip.hover title="Recargar"
                @click="loadData()">
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar placeholder="Buscar por ID de reporte, nombres o apellidos." @search="onSearch"
                @input="search = $event" class="flex-1" />
            </div>
          </section>

          <filter-menu :show="showFilters" @hide="showFilters = false" :options="filterOptions"
            :selectedOptionFilter="filters" @setFilters="setFilters"></filter-menu>
        </div>

        <div class="w-100 d-flex flex-wrap align-items-center mt-2" v-if="showFiltersList">
          <span v-for="(val, name) in filterList" v-bind:key="name" class="filter-item">
            {{ getFilterName(name, val) }}
            <button type="button" class="text-white p-0 bg-transparent border-0 ml-2" @click="deleteFilter(name)">
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Fecha</span>
            </div>

            <div>
              <span>ID <br> de reporte</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span v-local-date="o.createdAt"></span>
                </div>

                <div>
                  <span>{{ o.refNumber }}</span>
                </div>

                <div>
                  <button type="button" class="border-0 bg-transparent" @click="o.showMobileData = !o.showMobileData">
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link :to="{
                  name: 'complaints-details',
                  params: { complaintId: o.id },
                }" class="mr-2">
                  Ver datos
                </router-link>
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Tipo de reporte:</span>
                    <span>
                      <router-link :to="{ name: 'complaints-details', params: { complaintId: o.code } }">{{
                        getReportType(o.type).label }}</router-link>
                    </span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Nombre y apellidos:</span>
                    <span>{{ `${o.firstName} ${o.lastName}` }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Celular:</span>
                    <span>{{ o.mobile || '-' }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Menor de edad:</span>
                    <span>{{ o.isUnderAge ? "Sí" : "No" }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Bien contratado:</span>
                    <span>{{ getWeelType(o.wellType).label }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Monto:</span>
                    <span v-decimal:pen="o.wellAmount"></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Fecha de vencimiento:</span>
                    <span v-local-date="o.deadlineDate"></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Fecha de respuesta:</span>
                    <span v-local-date="o.respondedAt"></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Link:</span>
                    <span>
                      <a :href="`${webUrl}/${business.slug}/${o.code}`" target="_blank">
                        <LinkIcon class="fill-blue link-icon" />
                      </a>
                    </span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Estado:</span>
                    <span :class="`badge ${getStatus(o.status).color}`">{{
                      getStatus(o.status).label
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <section class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0">
            <div class="d-none d-md-flex">
              <button type="button" class="button-tooltip text-dark font-weight-bold" v-b-tooltip.hover title="Recargar"
                @click="loadData()">
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar placeholder="Buscar por ID de reporte, nombres o apellidos." @search="onSearch"
                @input="search = $event" class="flex-1" />
            </div>
          </section>

          <filter-menu :show="showFilters" @hide="showFilters = false" :options="filterOptions"
            :selectedOptionFilter="filters" @setFilters="setFilters"></filter-menu>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>ID de <br> reporte</th>
              <th>
                Tipo de <br />
                reporte
              </th>
              <th>Nombre y apellidos</th>
              <th>Celular</th>
              <th>
                Menor <br />
                de edad
              </th>
              <th>
                Bien <br />
                contratado
              </th>
              <th>Monto</th>
              <th>Fecha de <br> vencimiento</th>
              <th>Fecha de <br> respuesta</th>
              <th>Link</th>
              <th>Estado</th>
              <th class="pr-md-4">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="text-center" v-local-date="o.createdAt"></td>
              <td class="text-center">{{ o.refNumber }}</td>
              <td class="text-center"><router-link
                  :to="{ name: 'complaints-details', params: { complaintId: o.code } }">{{
                    getReportType(o.type).label }}</router-link></td>
              <td>
                {{ `${o.firstName} ${o.lastName}` }}
              </td>
              <td class="text-center">{{ o.mobile }}</td>
              <td class="text-center">{{ o.isUnderAge ? "Sí" : "No" }}</td>
              <td class="text-center">{{ getWeelType(o.wellType).label }}</td>
              <td class="text-center" v-decimal:pen="o.wellAmount"></td>
              <td class="text-center">
                <span v-local-date="o.deadlineDate" v-if="o.deadlineDate"></span>
                <span v-else>-</span>
              </td>
              <td class="text-center">
                <span v-local-date="o.respondedAt" v-if="o.respondedAt"></span>
                <span v-else>-</span>
              </td>
              <td class="text-center">
                <a :href="`${webUrl}/${business.slug}/${o.code}`" target="_blank">
                  <LinkIcon class="fill-blue link-icon" />
                </a>
              </td>
              <td class="text-center">
                <span :class="`badge ${getStatus(o.status).color}`">{{
                  getStatus(o.status).label
                }}</span>
              </td>
              <td class="text-center d_option pr-md-3">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem @click="
                      $router.push({
                        name: 'complaints-details',
                        params: { complaintId: o.code },
                      })
                      " text="Ver datos" />

                    <DropdownItem text="Archivar" @click="openStatusModal(o)"
                      v-if="getStatus(o.status).key == LocalConstants.ComplaintsStatus.RESPONDED.key" />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
          :changePageSize="changePageSize" v-if="list.length" />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>

    <ConfirmationModal :show="confirmationModal.show" @hide="closeConfirmationModal" @confirm="confirmModal" :data="confirmationModal" />
  </div>
</template>

<script>
import * as moment from "moment"

import { ComplaintsService } from "@/core/services";
import { Constants as LocalConstants } from '@/core/utils'

import {
  Alert,
  Constants,
  Util,
  PaginationMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
  FilterMenu,
  FilterMixin,
  LinkIcon,
  ConfirmationModalMixin,
  ConfirmationModal
} from "wize-admin";
import { mapGetters } from 'vuex';

export default {
  components: {
    SearchBar,
    FilterMenu,
    DropdownTable,
    DropdownItem,
    LinkIcon,
    ConfirmationModal
  },
  mixins: [PaginationMixin, FilterMixin, ConfirmationModalMixin],
  data() {
    return {
      LocalConstants,
      webUrl: process.env.VUE_APP_WEB_URL,
      list: [],
      tooltipType: null,
      filterOptions: [
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.ComplaintsStatus.PENDING,
            LocalConstants.ComplaintsStatus.RESPONDED,
            LocalConstants.ComplaintsStatus.FILED,
          ],
        },
        {
          label: "Fecha",
          key: "date",
          type: Constants.TypeFilters.DATE
        },
        {
          label: "Tipo de reporte",
          key: "type",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.ReportTypeValues.CLAIM,
            LocalConstants.ReportTypeValues.COMPLAINT,
          ],
        },
        {
          label: "Menor de edad",
          key: "isUnderAge",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.IsUnderage.YES,
            LocalConstants.IsUnderage.NOT
          ],
        },
        {
          label: "Bien contratado",
          key: "wellType",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.WellTypeValues.PRODUCT,
            LocalConstants.WellTypeValues.SERVICE
          ],
        }
      ],
    };
  },
  methods: {
    openStatusModal(o) {
      this.selectedOption = o;

      this.openConfirmationModal({
        title: "Archivar",
        description: "¿Está seguro que desea cambiar el estado?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "update") this.changeStatus();
    },
    // async changeStatus() {
    //   try {
    //     await this.$store.dispatch("app/loading", true);
    //     const resp = (
    //       await ComplaintsService.toggleStatus(
    //         this.selectedOption.id,
    //         !this.selectedOption.isActive
    //       )
    //     ).payload;

    //     const item = this.list.find((o) => {
    //       return o.id === resp.id;
    //     });
    //     if (item) {
    //       const index = this.list.indexOf(item);
    //       this.$set(this.list, index, resp);
    //     }
    //     Alert.success("Estado actualizado correctamente");
    //   } catch (ex) {
    //     console.error(ex);
    //     Alert.error(ex.errors.message);
    //   } finally {
    //     await this.$store.dispatch("app/loading", false);
    //   }
    // },
    async changeStatus() {
      try {
        this.$store.dispatch("app/loading", true);

        let response = await ComplaintsService.toggleStatus(
          this.selectedOption.id,
          3
        );

        if (response.status == "OK") {
          Alert.success("Se almacenó la información correctamente");

          // Emitir evento para actualizar tabla
          this.$emit("updated", {
            id: this.selectedOption.id,
            status: this.form.status,
          });
          this.close();
        }
      } catch (error) {
        Alert.error(error);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        let filters = JSON.parse(JSON.stringify(this.filters))

        for (const filter in filters) {
          if (filters[filter].selectedDate) {
            filters.startDate = moment(filters[filter].startDate).format("YYYY-MM-DD")
            filters.endDate = moment(filters[filter].endDate).format("YYYY-MM-DD")

            delete filters[filter]
          }
        }

        const params = { page: this.page - 1., size: this.pageSize, sort: 'createdAt,desc' };
        const data = { search: this.search, ...filters };

        const response = await ComplaintsService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        })

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;

      } catch (error) {
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getReportType(key) {
      return Util.searchValue(key, LocalConstants.ReportTypeValues);
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.ComplaintsStatus);
    },
    getWeelType(key) {
      return Util.searchValue(key, LocalConstants.WellTypeValues);
    }
  },
  async mounted() {
    await this.loadData();
  },
  computed: {
    ...mapGetters({
      business: 'app/getBusiness'
    })
  }
};
</script>

<style lang="stylus" scoped></style>
